import type { InputHTMLAttributes, TextareaHTMLAttributes, SelectHTMLAttributes, CSSProperties } from 'react';
import { inputStyle as baseInputStyle, labelBlockStyle, colors } from './styles';

/* ── Text input ──────────────────────────────────── */

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  inputStyle?: CSSProperties;
}

export function Input({ label, inputStyle: override, id, ...props }: InputProps) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div>
      {label && (
        <label htmlFor={inputId} style={labelBlockStyle}>{label}</label>
      )}
      <input
        id={inputId}
        style={{ ...baseInputStyle, ...override }}
        {...props}
      />
    </div>
  );
}

/* ── Textarea ────────────────────────────────────── */

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
}

export function Textarea({ label, id, style, ...props }: TextareaProps) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div>
      {label && (
        <label htmlFor={inputId} style={labelBlockStyle}>{label}</label>
      )}
      <textarea
        id={inputId}
        rows={4}
        style={{
          ...baseInputStyle,
          resize: 'vertical',
          minHeight: '100px',
          fontFamily: 'inherit',
          ...style,
        }}
        {...props}
      />
    </div>
  );
}

/* ── Select ──────────────────────────────────────── */

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export function Select({ label, options, id, style, ...props }: SelectProps) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div>
      {label && (
        <label htmlFor={inputId} style={labelBlockStyle}>{label}</label>
      )}
      <select
        id={inputId}
        style={{
          ...baseInputStyle,
          background: colors.cardBgDark,
          appearance: 'auto',
          ...style,
        }}
        {...props}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}
